import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import DeviceNameEdit from '../polling/pollingTopicEdit/DeviceNameEdit';

export type SelectDeviceNameDialogProps = {
    isOpen: boolean;
    onOK: (data: any) => void;
    onCancel: () => void;
    data: any;
};

export const SelectDeviceNameDialog_TJ360Version = (props: SelectDeviceNameDialogProps) => {
    const { isOpen, onOK, onCancel, data } = props;
    const [open, setOpen] = React.useState(isOpen);

    // Cancelボタンイベント
    const handleCancel = () => {
        setOpen(false);
        onCancel();
    };

    const handleUpdate = (data: any) => {
        setOpen(false);
        onOK(data);
    };

    return (
        <div>
            <Dialog open={open} maxWidth={"md"} fullWidth>
                <DialogTitle>DeviceName</DialogTitle>
                <DialogContent sx={{ pb: 1.5 }}>
                    <DeviceNameEdit onCancel={handleCancel} deviceName={data} onOK={(data) => handleUpdate(data)}></DeviceNameEdit>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default SelectDeviceNameDialog_TJ360Version;